import { useState } from 'react';
import { SortCondition } from 'shared/enums';

type TSort = { value: SortCondition | null; count: number };
// следит за кнопкой сортировки
// считает пользовательские клики
// возвращает объект с информацией о сортировке и функцию trigger щёлкалку
const usePullSort = (): [TSort, () => void] => {
  const [sortInfo, setSortInfo] = useState<TSort>({
    value: null,
    count: 0,
  });
  const handleSort = () => {
    if (sortInfo.value === null && sortInfo.count === 0) {
      setSortInfo(() => ({
        value: SortCondition.ASCEND,
        count: 1,
      }));
    }
    if (sortInfo.value === SortCondition.ASCEND && sortInfo.count === 1) {
      setSortInfo(() => ({
        value: SortCondition.DESCEND,
        count: 2,
      }));
    }
    if (sortInfo.count === 2 && sortInfo.value === SortCondition.DESCEND) {
      setSortInfo(() => ({
        value: null,
        count: 0,
      }));
    }
  };

  return [sortInfo, handleSort];
};

export default usePullSort;
